export default "__VITE_ASSET__CwU$CXrG__"